module.exports = __webpack_public_path__ + "assets/github.0bcc8f93.svg";